import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import { getEnv } from 'shared/base';

import { Providers } from './components/utils/providers';
import { PageRoutes } from './routes';

const disableSentry = getEnv(
  'NEXT_PUBLIC_DISABLE_SENTRY',
  process.env.NEXT_PUBLIC_DISABLE_SENTRY,
  'false',
);

if (disableSentry !== 'true') {
  Sentry.init({
    debug: false,
    dsn: process.env.NEXT_PUBLIC_PLATFORM_SENTRY_DSN,
    environment: process.env.SENTRY_ENV,
    normalizeDepth: 10,
    release: process.env.SENTRY_RELEASE,
    replaysOnErrorSampleRate: 1,
    replaysSessionSampleRate: 0,
    tracesSampleRate: 0,
  });
}

const root = document.querySelector('#root') as HTMLElement;

ReactDOM.createRoot(root).render(
  <Providers>
    <PageRoutes />
  </Providers>,
);
